import { Pipe, PipeTransform } from '@angular/core';
import {Message} from '@app/models/message';
import {AccessType} from '@app/modules/shared/data/constants';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';
import {Store} from '@ngxs/store';
import {
  RemoteUserAdditionalInfoStateModel,
  RemoteUserInfoStateModel,
  RemoteUsersInfoState
} from '@app/state/remote-users.state';

@Pipe({
  name: 'isMessageFrom'
})
export class IsMessageFromPipe implements PipeTransform {
  private localUser: LocalUser;
  private remoteUsers: { [key: string]: RemoteUserAdditionalInfoStateModel };

  constructor(private store: Store) {
    this.store.select(LocalUserState).subscribe((localUser: LocalUser): void => {
      this.localUser = localUser;
    });
    this.store.select(RemoteUsersInfoState).subscribe(({usersInfoById}: RemoteUserInfoStateModel): void => {
      this.remoteUsers = usersInfoById;
    });
  }

  public transform(message: Message, accessType: AccessType): boolean {
    if (message.senderId === this.localUser.id) {
      return this.localUser.accessType === accessType;
    } else {
      return this.remoteUsers[message.senderId].accessType === accessType;
    }
  }
}
